// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"36f3600a","198":"58b42f0d","289":"7270ada6","328":"7fdcdc36","448":"649e070c","623":"f50f41c9","804":"336c361b","821":"f66d2e5a","913":"4f7806ad"}[chunkId] + ".chunk.js";
};